// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import "./router/verification.js" //路由验证
import router from './router'
import store from './store'

//图标
import "./assets/font/iconfont.css"
// element
import './assets/element/theme/theme/index.css'
import ElementUI from 'element-ui'
Vue.use(ElementUI);

// 国际化语言
import i18n from './components/language/index.js'

//防抖 & 节流
import throttleDbounce from './assets/js/throttleDbounce.js';
Vue.use(throttleDbounce);
// script
import srcjs from './assets/js/scriptjs.js'

// 指令
import directives from "./assets/js/directives.js"
Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key])
});


// productionTip设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    i18n,
    srcjs,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js